module.exports = __webpack_public_path__ + "img/internet.a607ac6b.svg";